import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Headline as SecondaryHeadline,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const Title = styled.div`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const ItemContainer = styled.div`
  display: grid;
  grid:
    "item-1" min-content
    "item-2" min-content
    "item-3" min-content
    "item-4" min-content
    "item-5" min-content
    / 100%;
  row-gap: 16px;

  ${theme.breakpoints.only("tablet")} {
    grid:
      "item-1 item-1 item-1 item-2 item-2 item-2" min-content
      "divider divider divider divider divider divider" min-content
      "item-3 item-3 item-4 item-4 item-5 item-5" min-content
      / 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 0;
  }
`;

export const Divider = styled.div`
  grid-area: divider;

  inline-size: 100%;
  block-size: 0;
  border-block-start: 1px #dfdfdf solid;

  ${theme.breakpoints.not("tablet")} {
    display: none;
  }
`;

const Item = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: center;

  ${theme.breakpoints.not("tablet")} {
    :not(:first-of-type) {
      border-block-start: 1px #dfdfdf solid;

      padding-block-start: 12px;

      ${theme.breakpoints.up("desktop")} {
        padding-block-start: 16px;
      }
    }
  }
`;

export const Item1 = styled(Item)`
  grid-area: item-1;

  ${theme.breakpoints.only("tablet")} {
    padding-inline-end: 20px;
  }
`;

export const Item2 = styled(Item)`
  grid-area: item-2;

  ${theme.breakpoints.only("tablet")} {
    padding-inline-start: 20px;
    border-inline-start: 1px #dfdfdf solid;
  }
`;

export const Item3 = styled(Item)`
  grid-area: item-3;

  ${theme.breakpoints.only("tablet")} {
    padding-inline-end: 20px;
  }
`;

export const Item4 = styled(Item)`
  grid-area: item-4;

  ${theme.breakpoints.only("tablet")} {
    border-inline-start: 1px #dfdfdf solid;

    padding-inline: 20px;
  }
`;

export const Item5 = styled(Item)`
  grid-area: item-5;

  ${theme.breakpoints.only("tablet")} {
    border-inline-start: 1px #dfdfdf solid;

    padding-inline-start: 20px;
  }
`;

export const DisplayNumber = styled.div`
  flex: none;

  color: #2c4692;
  font-weight: 300;
  font-size: 48px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const StyledContentItem = styled(ContentItemHomeSecondaryV2)`
  flex: 1 1 0;

  min-inline-size: 0;

  ${SecondaryHeadline} {
    margin-block-end: 0;

    font-weight: 600;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: -0.36px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 16px;
      letter-spacing: -0.32px;
    }
  }

  ${SecondaryActionBar} {
    display: none;
  }
`;
